import React, { useState } from 'react';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import { Link } from 'react-scroll';

function Header() {
    const [nav, setNav] = useState(false);

    const toggleNav = () => {
        setNav(!nav);
    };

    const closeNav = () => {
        setNav(false);
    };

    return (
        <div className="flex justify-between items-center text-gray-200 px-6 py-7 max-w-[1300px] mx-auto h-24">
            <div className="flex items-center gap-4">
                <span className="w-[35px] h-[35px] text-black text-[18px] font-medium bg-sky-500 rounded-full flex items-center justify-center">
                    Y
                </span>
                <div className="leading-[20px]">
                    <h2 className="text-xl text-sky-300">Youcef</h2>
                    <p className="text-sm text-sky-950">Bada</p>
                </div>
            </div>

            <ul className="hidden md:flex gap-12 cursor-pointer text-gray-800 text-lg">
                <li className="relative group">
                    <Link to="about" smooth={true} offset={-70} duration={500} className="group-hover:text-sky-500">
                        About
                    </Link>
                    <span className="absolute bottom-0 left-0 w-full h-1 bg-sky-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                </li>
                <li className="relative group">
                    <Link to="portfolio" smooth={true} offset={-70} duration={500} className="group-hover:text-sky-500">
                        Portfolio
                    </Link>
                    <span className="absolute bottom-0 left-0 w-full h-1 bg-sky-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                </li>
                <li className="relative group">
                    <Link to="Contact" smooth={true} offset={-70} duration={500} className="group-hover:text-sky-500">
                        Contact
                    </Link>
                    <span className="absolute bottom-0 left-0 w-full h-1 bg-sky-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                </li>
            </ul>

            <div onClick={toggleNav} className="md:hidden z-30">
                {!nav ? <AiOutlineMenu size={20} /> : <AiOutlineClose size={20} />}
            </div>

            <div className={nav ? 'fixed inset-0 bg-white z-20 flex items-center justify-center' : 'hidden'}>
                <ul className="font-semibold text-2xl space-y-8 mt-24 text-gray-800">
                    <li className="hover:text-sky-500">
                        <Link to="about" onClick={closeNav} smooth={true} offset={-70} duration={500}>
                            About
                        </Link>
                    </li>
                    <li className="hover:text-sky-500">
                        <Link to="portfolio" onClick={closeNav} smooth={true} offset={-70} duration={500}>
                            Portfolio
                        </Link>
                    </li>
                    <li className="hover:text-sky-500">
                        <Link to="contact" onClick={closeNav} smooth={true} offset={-70} duration={500}>
                            Contact
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Header;
